export { default } from "p-memoize";
export * from "p-memoize";
